exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spouse-wrap{position:relative;margin:0 0 .75rem}.spouse-wrap .icon{position:absolute;right:-1.5rem;top:1em;width:1rem;height:1rem}.spouse-wrap .icon__svg{fill:#444;stroke:#444}.input-wrap--spouse{width:calc(100% - 30px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4af86651!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Spouse.vue
// module id = 268
// module chunks = 0